// 9fbef606107a605d69c0edbcd8029e5d
const red = {
  100: '#f3d7d7',
  200: '#f3d7d7',
  300: '#c84747',
  400: '#f53d3d',
  500: '#c8102e',
  600: '#c01f1f',
  700: '#3f3356',
  800: '#c70202',
  900: '#f4cfd5',
  1000: '#C8102E',
  1100: '#D0344D',
};

export default red;
